// extracted by mini-css-extract-plugin
module.exports = {"crss":"YR","imageWrapper":"ZR","visible":"_R"};